export default __webpack_public_path__ + "static/media/flag-english.5ccd2ebf.svg";